export const MERGE_CONTACT_FORM_KEYS = {
  NAME: "name",
  EMAIL_ID: "emailId",
  PHONE_NUMBER: "phone",
  INSTAGRAM_USERNAME: "instaUsername",
};

export const FIELD_MAP = {
  [MERGE_CONTACT_FORM_KEYS.NAME]: {
    label: "Name",
    placeholder: "Enter Name",
  },
  [MERGE_CONTACT_FORM_KEYS.EMAIL_ID]: {
    label: "Email ID",
    placeholder: "Enter Email Id",
  },
  [MERGE_CONTACT_FORM_KEYS.PHONE_NUMBER]: {
    label: "Phone no.",
    placeholder: "Enter Phone Number",
  },
  [MERGE_CONTACT_FORM_KEYS.INSTAGRAM_USERNAME]: {
    label: "Instagram username",
    placeholder: "Enter Instagram Username",
  },
};
